import Landmark from '../landmark-adapter';

const sendOnChangeStyleClickLandmark = (itemNumber, channelId, shopId, styleId) => {
    Landmark.sendClickLandmark([
        'zga',
        'variant',
        null,
        itemNumber,
        null,
        channelId, // TODO: channelId is not coming from services - delete?
        shopId,
        styleId,
        null,
        null
    ].join('\\'));
};

const sendOnChangeItemOptionClickLandmark = (context, itemOption, itemNumber, channelId, item, styleId, productId ) => {
    if (context === 'cartLayer') {
        Landmark.sendClickLandmark([
            'basket',
            'size',
            itemOption?.name,
            itemNumber,
            null,
            null,
            item.shopId,
            styleId,
            productId,
            itemOption.id
        ].join('\\'));
    } else if (context === 'lastseen') {
        Landmark.sendClickLandmark([
            'zga',
            'size',
            itemOption?.name,
            itemNumber,
            null,
            channelId, // TODO: channelId is not coming from services - delete?
            item.shopId,
            styleId,
            null,
            null
        ].join('\\'));
    }
};

const sendOnChangeItemClickLandmark = (context, item, channelId, styleId, productId) => {
    if (context === 'cartLayer') {
        Landmark.sendClickLandmark([
            'basket',
            'color',
            null,
            item.itemNumber,
            null,
            null,
            item.shopId,
            styleId,
            productId,
            item.id,
        ].join('\\'));
    } else if (context === 'lastseen') {
        Landmark.sendClickLandmark([
            'zga',
            'color',
            null,
            item.itemNumber,
            null,
            channelId, // TODO: channelId is not coming from services - delete?
            item.shopId,
            styleId,
            null,
            null,
        ].join('\\'));
    }
};

const sendOnChangeQuantityClickLandmark = () => Landmark.sendClickLandmark("basket_change_quantity");

const sendOnSubmitClickLandmark = () => Landmark.sendClickLandmark("basket_change_accepted");

const sendAddActionLandmark = (item, oldQuantity, newQuantity, changeType) => {
    const { itemId, itemOptionId, itemOptionName, itemNumber, shopId, masterStyleId, productId, singlePriceValue, promotionCode } = item;

    const isDeleteItemRequest = changeType === 'DELETE';
    const isQuantityIncreased = changeType === 'INCREASE';
    const isQuantityDecreased = changeType === 'DECREASE';
    let landmarkData = {};

    if (isQuantityIncreased) {
        const diffQuantity = newQuantity - oldQuantity;
        landmarkData = {
            landmark: 'action',
            addArtGr: itemOptionName,
            addItemoptionId: itemOptionId,
            addArtNr: itemNumber + promotionCode,
            addItemId: !itemOptionId ? itemId : '',
            addMenge: diffQuantity,
            addOrigin: 'update',
            addShop: shopId,
            addStyle: masterStyleId,
            addDigistyleId: productId,
        };
    } else if (isQuantityDecreased) {
        const diffQuantity = oldQuantity - newQuantity;
        landmarkData = {
            landmark: 'action',
            remArtGr: itemOptionName,
            remItemoptionId: itemOptionId,
            remArtNr: itemNumber + promotionCode,
            remItemId: !itemOptionId ? itemId : '',
            remOrigin: 'update',
            remMenge: diffQuantity,
            remShop: shopId,
            remStyle: masterStyleId,
            remDigistyleId: productId,
        };
    } else if (isDeleteItemRequest) {
        landmarkData = {
            landmark: 'action',
            remArtGr: itemOptionName,
            remItemoptionId: itemOptionId,
            remArtNr: itemNumber + promotionCode,
            remItemId: !itemOptionId ? itemId : '',
            remArtPreis: singlePriceValue,
            remMenge: oldQuantity,
            remShop: shopId,
            remStyle: masterStyleId,
            remDigistyleId: productId,
        };
    }

    Landmark.sendLandmark(landmarkData);
};

export default {
    sendOnChangeStyleClickLandmark,
    sendOnChangeItemClickLandmark,
    sendOnChangeItemOptionClickLandmark,
    sendOnChangeQuantityClickLandmark,
    sendOnSubmitClickLandmark,
    sendAddActionLandmark,
};
